import { Box, Typography, Stack } from "@mui/material";
import { FaPlay } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { convertTime } from "./VideoThumbnail";

export default function VideoThumbnailHorizontal({
  src,
  title,
  duration,
  categoryTitle,
  videoId,
  catagoryId,
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    const url = "/catagory/" + catagoryId + "/content/" + videoId;
    navigate(url);
  };

  const formatedDuration = convertTime(duration);
  return (
    <Stack
      flexDirection="row"
      gap={3}
      maxWidth="100%"
      alignItems="center"
      onClick={handleClick}
    >
      <Box
        position="relative"
        width="35%"
        maxWidth="200px"
        sx={{
          "& #icon": { opacity: 0 },
          ":hover": {
            "& img": {
              opacity: 0.3,
            },
            "& #icon": {
              opacity: 1,
            },
          },
        }}
      >
        <img
          src={src}
          alt=""
          style={{
            width: "100%",
            borderRadius: "0.4rem",
            transition: " 0.5s ease",
          }}
        />
        <FaPlay
          id="icon"
          fontSize="3rem"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            transition: " 0.5s ease",
            boxShadow: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
          }}
        />
      </Box>
      <Stack
        flexDirection="column"
        flexGrow={1}
        alignItems="flex-start"
        gap={0.5}
        maxWidth="60%"
        py={1}
      >
        <Typography
          variant="h6"
          fontWeight={400}
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          textOverflow="ellipsis"
          overflow="hidden"
          whiteSpace="nowrap"
        >
          {categoryTitle}
        </Typography>
        <Typography
          width="min-content"
          px={1}
          py={0}
          mt={0.7}
          variant="caption"
          bgcolor="secondary.main"
          borderRadius={3}
        >
          {formatedDuration}
        </Typography>
      </Stack>
    </Stack>
  );
}
